
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 233 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.9 25.1c0 15-5.3 24-16.2 24-11 0-16.2-9-16.2-24C.5 10.2 5.7 1 16.7 1s16.2 9.2 16.2 24.1zm-26.7 0C6.2 39.6 9.6 46 16.7 46c7 0 10.4-6.3 10.4-20.8 0-14.4-3.4-20.8-10.4-20.8S6.2 10.7 6.2 25.1zM55.6 1.6v46.8h-5.2V5.8l-8.7 4.8-1.2-2.8 10.8-6.2h4.3zm16.5 13.6c.8 0 1.7.3 2.3.8.7.7 1 1.6 1 2.5 0 1-.3 1.8-1 2.4a3.4 3.4 0 01-4.5 0c-.7-.6-1-1.5-1-2.4 0-.9.3-1.8 1-2.5.6-.5 1.4-.8 2.2-.8zm0 27.3c.8 0 1.7.3 2.3.8.7.7 1 1.6 1 2.5 0 1-.3 1.8-1 2.4a3.4 3.4 0 01-4.5 0c-.7-.6-1-1.5-1-2.4 0-.9.3-1.8 1-2.5.6-.5 1.4-.8 2.2-.8zm39.9 6H84.2V44c2.2-.7 20.8-16 20.8-29.5 0-6.7-2.3-10-9-10-5.4 0-10.2 4-10.2 4L85 5.2S90 1 96.7 1c10 0 14 5.5 14 13 0 12-13.7 24-20.7 29.5h22v5zm13.8-24.2l13.3-17.7h-18.8l.3-5H144V5l-13 17c.6-.2 1.3-.3 2-.3 7.6 0 12.9 5 12.9 13 0 9.1-6.5 14.4-15.3 14.4-8.7 0-12.6-5-12.6-5l1.8-2.9s3.8 4.5 10.3 4.5c6.9 0 10.3-4 10.3-11 0-6.2-3-9.9-8.6-9.9-2.5 0-4.2 1.6-4.2 1.6l-1.9-2.1zm32.4-9.1c.8 0 1.6.3 2.3.8.6.7.9 1.6.9 2.5 0 1-.3 1.8-1 2.4-.6.6-1.4.9-2.2.9s-1.6-.3-2.3-.9c-.7-.6-1-1.5-1-2.4 0-.9.3-1.8 1-2.5.7-.5 1.5-.8 2.3-.8zm0 27.3c.8 0 1.6.3 2.3.8.6.7.9 1.6.9 2.5 0 1-.3 1.8-1 2.4-.6.6-1.4.9-2.2.9s-1.6-.3-2.3-.9c-.7-.6-1-1.5-1-2.4 0-.9.3-1.8 1-2.5.7-.5 1.5-.8 2.3-.8zM186 1.6c-3.1 12-8.5 23.9-12.6 31.8h16.4l1.3-25h4v25h5.2v2.9l-5.1.3v11.8h-5.4V36.7h-20.1l-.4-2.7c4-7.8 8.7-21.1 11.7-33l5 .7zm44.4 5.1h-16.6l-1.2 14a15 15 0 015.2-1c9 0 15 5.4 15 14 0 9.8-7.5 15.5-16.5 15.5-8.2 0-11.8-5-11.8-5l1.8-2.7s3.3 4.2 9.8 4.2c7 0 11.3-4.3 11.3-12 0-6.7-4-10.9-10-10.9-3.4 0-5.7 1.4-6.2 2l-.1.3-2.2-.3 2.2-23.1h19.6l-.3 5z"}})])
          )
        }
      }
    